import { Plugin } from "@ckeditor/ckeditor5-core";
import { ButtonView } from "@ckeditor/ckeditor5-ui";

import ImageIcon from "./image.svg";

export default class PreviewImageInsertUI extends Plugin {
  destroy() {
    console.debug("Removing listener for cde:openInsertImageDialog");
    this.editor.off("cde:openInsertImageDialog");
  }

  init() {
    const editor = this.editor;
    const t = editor.t;

    editor.ui.componentFactory.add("insertImage", (locale) => {
      const command = editor.commands.get("insertImage");
      const insertImageButtonView = new ButtonView();

      insertImageButtonView.set({
        icon: ImageIcon,
        isOn: false,
        label: t("Insert Image"),
        tooltip: true,
      });

      insertImageButtonView
        .bind("isOn", "isEnabled")
        .to(command, "insertImage", "isEnabled");
      insertImageButtonView.on("execute", (e) => {
        editor.fire("cde:openInsertImageDialog");
      });
      return insertImageButtonView;
    });
  }
}
